import React from 'react';
import {compose, graphql} from 'react-apollo';
import gql from 'graphql-tag';

import {Card, Input} from 'ui-kit';
import {FormFooter} from '../../../FormFooter';

import * as styles from './IdentityForm.module.css';

class IdentityForm extends React.Component {
  state = {
    status: null, // null | loading | success
    practiceName: this.props.initialValues.name || '',
    phone: this.props.initialValues.phone || '',
    email: this.props.initialValues.email || '',
  };

  render() {
    const {practiceName, phone, email, status} = this.state;

    return (
      <Card>
        <form method="post" onSubmit={this.handleFormSubmit}>
          <Input
            label="Practice name"
            value={practiceName}
            name="practiceName"
            onChange={this.handleInputChange}
          />

          <div className={styles.ContactContainer}>
            <div className={styles.Email}>
              <Input
                label="Primary contact email"
                value={email}
                name="email"
                onChange={this.handleInputChange}
              />
            </div>
            <div className={styles.Phone}>
              <Input
                label="Primary phone number"
                value={phone}
                name="phone"
                onChange={this.handleInputChange}
              />
            </div>
          </div>

          <FormFooter status={status} />
        </form>
      </Card>
    );
  }

  handleInputChange = event => {
    const {name, value} = event.target;

    this.setState({[name]: value});
  };

  handleFormSubmit = async event => {
    event.preventDefault();

    this.setState({status: 'loading'});

    const {mutate} = this.props;
    const {name, email, phone} = this.state;

    const {data} = await mutate({
      variables: {
        input: {
          name,
          contactEmail: email,
          phone,
        },
      },
    });

    if (data.updatePractice.errors.length === 0) {
      this.setState({status: 'success'});

      window.setTimeout(() => {
        this.setState({status: null});
      }, 2000);
    }
  };
}

export default compose(
  graphql(
    gql`
      mutation IdentityFormMutation($input: PracticeInput!) {
        updatePractice(input: $input) {
          errors {
            path
            message
          }
          practice {
            id
          }
        }
      }
    `,
  ),
)(IdentityForm);
